module.exports = __webpack_public_path__ + "7120b7673b36943c47778b3f161e6fed.svg";